import { render } from "./modal_facture_payment.vue?vue&type=template&id=3d56f1ad"
import script from "./modal_facture_payment.vue?vue&type=script&lang=js"
export * from "./modal_facture_payment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__